require('./modules/body_class.js');
require('./modules/slide.js');
require('./modules/nav.js');
require('./modules/sp_header.js');
// require('./modules/instagram_api.js');